export const supportedLocales = ['en', 'pl'] as const
export type SupportedLocale = (typeof supportedLocales)[number]

export function resolveLocale(locale: string): SupportedLocale {
  if (supportedLocales.includes(locale as SupportedLocale)) {
    return locale as SupportedLocale
  }
  return 'en'
}
